import React, { useState, useEffect } from 'react';
import { Contract, Employee } from '../../../types';
import { Formik, FieldArray } from 'formik';
import { Form, SubmitButton, Input, DatePicker, Select } from 'formik-antd';
import { Row, Col, Button, Typography, Descriptions } from 'antd';
import moment from 'moment';
import PageHeader from '../../../Components/PageHeader';
import ContentWrapper from '../../../Components/ContentWrapper';
import withAppState, { IAppStateComponentProps } from '../../../state/withAppState';
import TimesheetList from '../../Timesheets/ListByEmployee';
import { browserHistory } from '../../../Routers/MainRouter';
import { API } from 'aws-amplify';

const ContractForm = ({
  record,
  close,
  appState,
}: IAppStateComponentProps & {
  record: Contract | null;
  close: () => void;
}): React.ReactElement => {
  const readOnly = true;
  const user = appState.user?.id;
  const breadcrumbs = [
    { path: '/contractors', breadcrumbName: 'Contractors' },
    { path: ':id', breadcrumbName: record?.employee_id[1] },
  ];
  const timesheetBreadcrumbs = [
    { path: '/contractors', breadcrumbName: 'Contractors' },
    { path: `${record?.id}`, breadcrumbName: record?.employee_id[1] },
  ];
  // const [employee, setEmployee] = useState<Employee>();
  // useEffect(() => {
  //   const loadEmployee = async (): Promise<void> => {
  //     if (record?.employee_id) {
  //       const emp = await API.get('EhcmsPortalApi', `/customer/employees/${record?.employee_id[0]}`, {});
  //       setEmployee(emp);
  //     }
  //   };
  //   loadEmployee();
  // }, [record?.employee_id]);
  return (
    <div data-testid="timesheet-form">
      <PageHeader title={''} routes={breadcrumbs} />
      <ContentWrapper>
        <Typography.Title>{record?.employee_id[1]}</Typography.Title>
        <Typography.Title level={3}>Contract Details</Typography.Title>
        <Descriptions layout="vertical" bordered>
          <Descriptions.Item label="Title">{record?.job_id[1]}</Descriptions.Item>
          <Descriptions.Item label="Start Date">
            {record?.date_start && moment(record?.date_start).format('MMMM Do, YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="End Date">
            {record?.date_end && moment(record?.date_end).format('MMMM Do, YYYY')}
          </Descriptions.Item>
        </Descriptions>
        <br />
        <br />
        <Typography.Title level={3}>Timesheets</Typography.Title>
        {record?.employee_id[0] && (
          <TimesheetList
            employeeId={record?.employee_id[0]}
            history={browserHistory}
            breadcrumbs={timesheetBreadcrumbs}
          />
        )}
        {/* <Row gutter={16}>
            <Col span={12}>
              <Form.Item name={`fromDate`} label="From">
                <DatePicker name="fromDate" disabled />
              </Form.Item>
              <Form.Item name={`status`} label="Status">
                <Input name="status" disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name={`toDate`} label="To">
                <DatePicker name="toDate" disabled />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row
            gutter={16}
            style={{
              background: '#EFEFEF',
              padding: '10px 0',
            }}
          >
            <Col span={8}>Date</Col>
            <Col span={8}>Activity</Col>
            <Col span={8}>Leave Type</Col>
          </Row> */}
      </ContentWrapper>
    </div>
  );
};

export default withAppState(ContractForm);
